// Filters out style-only props so they don't end up in the DOM
export const createShouldForwardProp = (excludedProps: string[]) => {
    return (prop: PropertyKey) => !excludedProps.includes(prop as string);
};
